import { ConfirmationMessage } from './ConfirmationMessage';

export default ConfirmationMessage;
